export const SAME_FEE_INPUT = 'SAME_FEE_INPUT';
